/** Typography tokens aligned with website-amitasoft tailwind.config.js */
export const AMITASOFT_TYPO = {
  fontFamily: "Inter, sans-serif",

  hero: {
    fontSize: "clamp(2rem, 4vw, 3.4rem)",
    lineHeight: 1.12,
    letterSpacing: "-0.047em",
  },
  section: {
    fontSize: "clamp(2rem, 4.32vw, 3.69rem)",
    lineHeight: 1.12,
    letterSpacing: "-0.046em",
  },
  cardTitle: {
    fontSize: "clamp(1rem, 1.45vw, 1.25rem)",
    lineHeight: 1.35,
    letterSpacing: "-0.046em",
    fontWeight: 700,
  },
  cardBody: {
    fontSize: "0.875rem",
    lineHeight: 1.55,
  },
  body: {
    fontSize: "clamp(0.875rem, 1.44vw, 1.25rem)",
    lineHeight: 1.5,
  },
  bodySm: {
    fontSize: "0.8125rem",
    lineHeight: 1.45,
  },
  nav: {
    fontSize: "clamp(1rem, 1.83vw, 1.5rem)",
    lineHeight: 1.12,
    letterSpacing: "-0.046em",
  },
  buttonSm: {
    fontSize: "clamp(0.875rem, 1.56vw, 1.375rem)",
    lineHeight: 1.2,
    letterSpacing: "0.045em",
  },
  pagePadding: "clamp(1.25rem, 5.64vw, 4.8125rem)",
};

/** Compact carousel CTA — must fit narrow grid columns without clipping */
export const readMoreButtonSx = {
  background: "linear-gradient(45deg, #6A8AFF 14.64%, #B2FBFF 85.36%)",
  color: "#ffffff",
  border: "none",
  fontFamily: AMITASOFT_TYPO.fontFamily,
  fontWeight: 600,
  fontSize: "0.75rem",
  lineHeight: 1.2,
  letterSpacing: "0.01em",
  textTransform: "none",
  minHeight: 30,
  py: 0.5,
  px: 1.25,
  width: "auto",
  maxWidth: "100%",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  borderRadius: "999px",
  "&:hover": {
    opacity: 0.9,
    background: "linear-gradient(45deg, #6A8AFF 14.64%, #B2FBFF 85.36%)",
    color: "#ffffff",
  },
};
